/* eslint-disable jsx-a11y/label-has-associated-control */
import React, { FC } from "react";
import styles from "./PrivacyToggleSwitch.module.css";

interface PrivacyToggleSwitchProps {
    isPrivate: boolean;
    onToggle: (value: boolean) => void;
}

const PrivacyToggleSwitch: FC<PrivacyToggleSwitchProps> = ({
    isPrivate,
    onToggle,
}) => {
    const handleChange = () => {
        onToggle(!isPrivate);
    };

    return (
        <div className={styles.toggleSwitch}>
            <div className={styles.switchLabelWrapper}>
                <span
                    className={`${styles.switchLabel} ${
                        isPrivate ? styles.selected : ""
                    }`}
                >
                    Private
                </span>
            </div>
            <label className={styles.switch}>
                <input
                    type="checkbox"
                    className={styles.hiddenInput}
                    checked={!isPrivate}
                    onChange={handleChange}
                />
                <span className={styles.slider} />
            </label>
            <div className={styles.switchLabelWrapper}>
                <span
                    className={`${styles.switchLabel} ${
                        !isPrivate ? styles.selected : ""
                    }`}
                >
                    Public
                </span>
            </div>
        </div>
    );
};

export default PrivacyToggleSwitch;
